import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M7.147 35.37l10.856-10.859 10.854 10.86a1.978 1.978 0 002.895 0l3.619-3.623a1.978 1.978 0 000-2.894L24.516 17.997 35.37 7.142a2.006 2.006 0 000-2.894L31.753.628a1.995 1.995 0 00-2.895 0L18.003 11.485 7.147.629a1.98 1.98 0 00-2.894 0L.633 4.248a1.97 1.97 0 000 2.894A8847.23 8847.23 0 0011.49 17.997L.634 28.854a2.02 2.02 0 000 2.894l3.619 3.622a1.98 1.98 0 002.894 0z",
      stroke: "none"
    })]
  });
};
const IconTimes = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Times__IconTimes",
  componentId: "sc-1yon2hf-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconTimes };
